import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

function PublicRoute({ children }) {
  const { data: user } = useSelector((state) => state.user);

  return user ? <Navigate to="/dashboard" /> : children;
}

export default React.memo(PublicRoute);
